// src/shared/api-client/endpoints/issues.js
// Political Intelligence CRM — Issues & Committees API endpoints

import { baseApi } from "../baseApi";

const issuesApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    // -------------------------------------------------------------------------
    // ISSUES
    // -------------------------------------------------------------------------

    getIssues: builder.query({
      query: (params = {}) => ({ url: "/api/issues", params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.issues.map(({ id }) => ({
                type: "PoliticalIssue",
                id,
              })),
              { type: "PoliticalIssue", id: "LIST" },
            ]
          : [{ type: "PoliticalIssue", id: "LIST" }],
    }),

    createIssue: builder.mutation({
      query: (data) => ({ url: "/api/issues", method: "POST", body: data }),
      invalidatesTags: [{ type: "PoliticalIssue", id: "LIST" }],
    }),

    updateIssue: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/issues/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "PoliticalIssue", id },
        { type: "PoliticalIssue", id: "LIST" },
        // Stances reference issues — refresh any open official stance panels
        { type: "OfficialStance", id: "LIST" },
      ],
    }),

    deleteIssue: builder.mutation({
      query: (id) => ({ url: `/api/issues/${id}`, method: "DELETE" }),
      invalidatesTags: (_result, _error, id) => [
        { type: "PoliticalIssue", id },
        { type: "PoliticalIssue", id: "LIST" },
      ],
    }),

    // -------------------------------------------------------------------------
    // COMMITTEES
    // -------------------------------------------------------------------------

    getCommittees: builder.query({
      query: (params = {}) => ({ url: "/api/committees", params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result.data.committees.map(({ id }) => ({
                type: "PoliticalCommittee",
                id,
              })),
              { type: "PoliticalCommittee", id: "LIST" },
            ]
          : [{ type: "PoliticalCommittee", id: "LIST" }],
    }),

    createCommittee: builder.mutation({
      query: (data) => ({ url: "/api/committees", method: "POST", body: data }),
      invalidatesTags: [{ type: "PoliticalCommittee", id: "LIST" }],
    }),

    updateCommittee: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/api/committees/${id}`,
        method: "PUT",
        body: data,
      }),
      invalidatesTags: (_result, _error, { id }) => [
        { type: "PoliticalCommittee", id },
        { type: "PoliticalCommittee", id: "LIST" },
      ],
    }),

    deleteCommittee: builder.mutation({
      query: (id) => ({ url: `/api/committees/${id}`, method: "DELETE" }),
      invalidatesTags: (_result, _error, id) => [
        { type: "PoliticalCommittee", id },
        { type: "PoliticalCommittee", id: "LIST" },
      ],
    }),
  }),
});

// Issues
export const useGetIssuesQuery = issuesApi.useGetIssuesQuery;
export const useCreateIssueMutation = issuesApi.useCreateIssueMutation;
export const useUpdateIssueMutation = issuesApi.useUpdateIssueMutation;
export const useDeleteIssueMutation = issuesApi.useDeleteIssueMutation;

// Committees
export const useGetCommitteesQuery = issuesApi.useGetCommitteesQuery;
export const useCreateCommitteeMutation = issuesApi.useCreateCommitteeMutation;
export const useUpdateCommitteeMutation = issuesApi.useUpdateCommitteeMutation;
export const useDeleteCommitteeMutation = issuesApi.useDeleteCommitteeMutation;
